import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

type TooltipWrapperProps = {
  align?: "start" | "center" | "end";
  alignOffset?: number;
  content: React.ReactNode;
  contentClasses?: string;
  delay?: number;
  side?: "top" | "right" | "bottom" | "left";
  sideOffset?: number;
  trigger: React.ReactNode;
  asChild?: boolean;
};

export default function TooltipWrapper({
  align,
  alignOffset,
  content,
  contentClasses,
  delay,
  side,
  sideOffset = 20,
  trigger,
  asChild,
}: TooltipWrapperProps) {
  return (
    <TooltipProvider delayDuration={delay || 200}>
      <Tooltip>
        <TooltipTrigger asChild={asChild}>{trigger}</TooltipTrigger>
        <TooltipContent
          align={align || "center"}
          alignOffset={alignOffset || 4}
          className={cn("border border-muted/60 shadow-sm", contentClasses)}
          side={side || "top"}
          sideOffset={sideOffset}
        >
          {content}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
